export const json = {
  valid(str) {
    try {
      JSON.parse(str)
    } catch (e) {
      return false
    }
    return true
  }
}



// WEBPACK FOOTER //
// ./src/core/utils/json.js